import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/sr';
import 'moment/locale/de';
import { getRegion } from '../helpers/getRegion';

export const translation = {
  com: {
    common: {
      lostTicket: 'Lost your Ticket?',
      login: 'Login',
      contact: 'Contact',
      policy: 'Privacy Policy',
      terms: 'Terms of Service',
      cookie: 'Cookie Statement',
      learnMore: 'Learn More',
      knowledgeBtn: 'Knowledge base',
      ourPartnerships: 'Our loyal Partnerships',
    },
    hero: {
      title: 'Your full control in ticketing',
      description:
        'A single platform where you can manage all your commerce. Connect with your audience easily, sell your products efficiently, and collect your payments instantly.',
      features: 'Easy setup - Efficient sales - Instant payment',
      requestDemo: 'Request demo',
    },
    asEasyAs: {
      title: 'It’s as easy as',
      sell: {
        title: 'Sell',
        text: 'One system, that will give you all the tools you need. Sell anything you want, whenever and wherever you like. Online through your website or social channels, or in-person using POS application. From tickets and products to reservations and even monthly subscriptions —everything is possible.',
      },
      collect: {
        title: 'Collect',
        text: 'We know cash flow is essential to your business success. That`s why we`ve connected your bank account directly to your store with our zero-touch policy. Every payment is instantly split into your earnings, our product fee, and the payment provider`s transaction fee—simple and transparent.',
      },
      monetize: {
        title: 'Monetize',
        text: 'We believe in the power of your data, therefor we developed several features to maximize your profits and create additional revenue streams for your end-users (ticket buyers). Our white-label community app makes upselling events easy and integrates seamlessly with third-party sponsorships and marketing campaigns.',
      },
    },
    yourSix: {
      title: 'Your six of SIXTIX',
      shop: {
        title: 'Shop',
        text1: 'CREATE ',
        text2: ' SHOP',
        your: 'YOUR',
        tooltip:
          "”From customizing colors and requirements to offering buyer discounts—whether you need assigned seating or reservations, we've got you covered.”",
      },
      marketing: {
        title: 'Marketing',
        text1: 'SELL ',
        text2: ' PRODUCTS',
        your: 'YOUR',
        tooltip:
          '“Manage everything easily from your phone, website, or own application. Set it up quickly via your personal dashboard, giving you full control over what, when, where, and who.”',
      },
      finance: {
        title: 'Finance',
        text1: 'GET ',
        text2: ' MONEY',
        your: 'YOUR',
        tooltip:
          '“With our zero-touch money policy, you have direct control over all your cash flow settings.”',
      },
      statistics: {
        title: 'Statistics',
        text1: 'GROW ',
        text2: ' DATABASE',
        your: 'YOUR',
        tooltip:
          '“Your active database is your greatest asset—start leveraging it!”',
      },
      settings: {
        title: 'Settings',
        text1: 'CONTROL ',
        text2: ' ENTRANCE',
        your: 'YOUR',
        tooltip: '“Great customer value starts with great service.”',
      },
      dashboard: {
        title: 'Dashboard',
        text1: 'GET ',
        text2: ' CONTROL',
        your: 'YOUR',
        tooltip: '”The days of depending on your provider are over!”',
      },
    },
    takingBackControl: {
      title: 'Taking back Control!',
      slider: 'GLOBAL NEWSFEED SLIDER',
    },
    agenda: {
      title: 'Agenda',
      showMore: 'Show more',
      tickets: 'Tickets',
      startDate: 'Start date',
      endDate: 'End date',
    },
    about: {
      title: 'What do you want to know about us?',
      sectionsList: [
        {
          title: 'FAQ SIXTIX',
          subsections: [
            {
              title: 'How do I use SIXTIX?',
              text: 'Just sign up to create your account as a seller, buyer or reseller — and then start creating your events. SIXTIX makes it easy to create, manage, and promote your events. From email marketing to social media integration, you’ll discover advanced tools designed to help you sell more tickets and grow your business all in one place.',
            },
          ],
        },
        {
          title: 'TICKET DASHBOARD',
          subsections: [
            {
              title: 'How do I create multiple ticket types on SIXTIX?',
              text: 'With SIXTIX, you can easily create multiple ticket types such as Early Bird or VIP, optimizing your online sales by appealing to different budgets and encouraging more ticket purchases.',
            },
            {
              title: 'Where can I find support that can help me with sales?',
              text: 'Under the heading "Support" in your dashboard.',
            },
            {
              title: 'Where can I find visitor data and sales insights?',
              text: 'Under sales (statistics), data can be found on sales statistics. And downloadable on the “Report page”.',
            },
            {
              title: 'Can I offer special prize tickets?',
              text: 'You can send out any ticket with a special prize through your internal shop.',
            },
            {
              title: 'Do you offer special pricing for nonprofits?',
              text: 'Yes, we offer discounted Ticketing Fees on donation tickets, so more of your funds go directly to your cause. We’re committed to supporting non-profits with tailored features designed to help you and your community thrive.',
            },
            {
              title: 'What are Sealed Tickets?',
              text: 'Sealed Tickets are tickets that become available for download shortly before an event starts. We do this at the organizer’s request to prevent fraud and discourage unfair trading of tickets.',
            },
            {
              title: 'My ticket shop is no longer active. What now?',
              text: 'Check if the time and date of the event are set correctly. You do this via “Event page”, edit event. Check if the event is still active. You do this via “Event page”, edit event.',
            },
            {
              title:
                'My tickets are no longer visible in the ticket shop. What now?',
              text: 'Check in the options of the ticket whether the ticket date and time are set correctly. You do this via “Ticket page”.',
            },
            {
              title: 'Stop sales / deactivate my ticket shop',
              text: 'You can (temporarily) stop the sale of your event. Go to the “Event page”.',
            },
            {
              title: 'I want to sell a group ticket',
              text: 'Create a ticket via "Ticket page" and indicate the name of the group ticket, the total capacity of all group tickets that you want to sell, and the total price of the group ticket.',
            },
            {
              title: 'Sending guest list tickets',
              text: 'Via "Internal shop", internal shop has the possibilities to send out any ticket with any price.',
            },
            {
              title: 'I want to increase/decrease my ticket sales capacity?',
              text: 'Go to "Ticket page”.',
            },
            {
              title: 'I want to add an extra/different ticket during sales',
              text: 'Go to “Event page”.',
            },
            {
              title: 'I want to withdraw a ticket from the sale',
              text: 'Go to “Event page”.',
            },
            {
              title:
                'In addition to tickets, I also want to sell coins, parking tickets, merchandise, and the likes.',
              text: 'You can create an additional ticket for this on the "Ticket Page".',
            },
          ],
        },
        {
          title: 'TICKETS & SCANNING',
          subsections: [
            {
              title: 'How do I scan tickets?',
              text: 'To scan the tickets, use the SIXTIX scanner application. You can download this on a smartphone.',
            },
            {
              title:
                'The ticket buyer has not received a ticket and has paid. What can I do?',
              text: 'You can search the buyer in the “Transaction page” and resend his tickets or edit his email and resend it.',
            },
            {
              title: 'Log in to the scanner app.',
              text: 'You can scan tickets via the SIXTIX scanner app. Log in with your username + password or a QR code. If you do not want to share your username + password with a scan team at the door, you can create a login QR code via "Team page".',
            },
            {
              title: 'Problem’s logging in scanner app',
              text: 'Use the same username + password as the account. A login QR code can be created in the account. Go to "Team page", select the event and tickets, save. The QR code can be used to log in with the scanner app.',
            },
            {
              title: 'A person at the door has paid but no ticket. What now?',
              text: 'In the scanner app, a ticket buyer can be searched by name or email address via the magnifying glass and tickets can be scanned. All sales data can be found via the “Event transaction page”. Tickets can be resent through the “Event transaction page”.',
            },
            {
              title: 'Tickets do not scan.',
              text: 'Does the person have a valid ticket? To verify, a ticket can be found “Event transaction page”.',
            },
            {
              title: 'Scan results data',
              text: 'These are visible in the app but also via the dashboard “Event transaction page”.',
            },
            {
              title: 'Scan results problem',
              text: 'Is the phone or scanner connected to the internet? Has the correct event been selected?',
            },
          ],
        },
        {
          title: 'TICKET BUYER',
          subsections: [
            {
              title: 'How do I purchase tickets through your service?',
              text: 'You can purchase tickets by visiting our website. Simply select the event you’re interested in, choose your desired ticket, and proceed to checkout.',
            },
            {
              title: 'Can tickets be scanned from my phone?',
              text: 'Yes, it can.',
            },
            {
              title: 'How do I add a card or ticket to my wallet?',
              text: 'To add a card or ticket to your wallet, press add to wallet button in the confirmation email.',
            },
            {
              title: 'Is "Add to Wallet" secure?',
              text: "Yes, adding items to your wallet is generally secure. Wallet apps use encryption and secure protocols to protect your information. Always ensure you're using official apps and platforms to maintain security.",
            },
            {
              title: 'Can I use my wallet items offline?',
              text: 'Yes, many wallet items, such as tickets, can be accessed offline once they are added. However, some tickets like season pass or real-time may require an internet connection.',
            },
            {
              title: 'My tickets are sealed',
              text: 'If you\'ve purchased tickets to an event, you may have noticed that one or more of your tickets are marked as "sealed". This means that your tickets won’t be available for download until shortly before the event. Organizers use Sealed Tickets to prevent fraud and discourage unfair trading of tickets. The tickets will usually be available a few days before the event.',
            },
            {
              title: 'Where can I request a refund?',
              text: 'Send a request to the promotor/organization?',
            },
            {
              title: 'When can I expect my refund?',
              text: 'When you have to request a refund, after validation your money is instantly on your account.',
            },
            {
              title: 'Tickets not received.',
              text: 'Send a request to the promotor/organization?',
            },
            {
              title: 'I haven’t received a confirmation email',
              text: 'Contact promotor/organization with your transaction ID for validation, organization has the possibility to resend your ticket to proper email address.',
            },
            {
              title: 'Personalization of your tickets',
              text: 'If personalization is needed it will be asked during buying process.',
            },
            {
              title: 'My ticket is invalid or cancelled',
              text: 'If you notice that one or more of your tickets are marked as invalid or cancelled, it means that the ticket(s) will no longer grant you entry to the event. A ticket can be invalidated or cancelled for various reasons.',
            },
            {
              title: 'My payment was cancelled',
              text: 'Unfortunately, your order has been cancelled. Your tickets weren’t reserved; therefore, you do not have valid tickets for the event. You could try placing a new order with a different payment method.',
            },
          ],
        },
      ],
    },
    yourSixElements: {
      shop: [
        {
          title: 'Full white-label',
          text: "Your brand is the connection between your buyer and you. That's why we take this fact serious, from the data info that is requirement for purchase till colors of your shop. Even the buyer flow.",
          label: 'full-white-label',
        },
        {
          title: 'All type of shop available',
          text: 'Seating / Time slots / products / regular ticketing / season card / memberships / reservation / pre-register.\nWhat you want to sell, and how? You know your product better than we do. We are focussing to cover all possibilities and to maintain a user-friendly user flow.',
          label: 'all-type-of-shop',
        },
        {
          title: 'Secured Costumer experience',
          text: 'Put your event to the next level. With the latest technology available. Seamless integration with apple and google wallet for an easy excess experience. Or protect secondary market with dynamic QR. Rather high end? Use our protected NFC solutions for physical cards.',
          label: 'secured-costumer',
        },
        {
          title: 'Personal contact',
          text: "Create a communication channel by using Buyer / Member login. It's more than only a chat function. Buyer/Members will have a clear profile with purchases, special 1on1 deals or early access to sudden products or tickets.",
          label: 'personal-contact',
        },
        {
          title:
            'Multiple shops in shop (tracking / invites / discount / secured)',
          text: "We understand the need of selling, so we tried to make it as usable and flexible as possible. Selling true different links to track your statistics and improve per campaign. Invite your sponsor's true protected link (with discount), send your host extra guest-list tickets. Sell true ambassadors on the street. It's all possible. Let us know if you have a specific way of selling that you can't do with our software, and we will work together for a solution.",
          label: 'multiple-shops',
        },
      ],
      marketing: [
        {
          title: 'Direct short link',
          text: 'We are with you, time is everything. So no shorturl.com needed, just type your unique reference in create-link environment sixtix.com/reference.',
          label: 'direct-short-link',
        },
        {
          title: 'Iframe integration of any website (and mobile responsive)',
          text: 'Create a ticket button anywhere—offline with QR or online using iframe. Set it once and never worry again; it’s fully responsive and automatically syncs with your event settings.',
          label: 'iframe-integration',
        },
        {
          title: 'P.O.S. app integration',
          text: 'When we say you can sell anywhere, we mean anywhere—not just online. Download our accreditation app with built-in POS functionality, letting you sell any configured product via QR codes, payment links, or Tap2Pay (accepting Apple Pay, Google Pay, and physical cards).',
          label: 'pos-integration',
        },
      ],
      finance: [
        {
          title: 'Choose your online payment options',
          text: "If your preferred payment method isn't available, let us know—we'll integrate it for you!",
          label: 'choose-online-payment-options',
        },
        {
          title: 'Connect tap2pay on P.O.S. app',
          text: 'Turn any Android or iOS device into a local payment terminal, directly connected to the POS functionality within our accreditation app.',
          label: 'connect-tap2pay-pos',
        },
        {
          title: 'Connect your bank account to wallet (split payment)',
          text: "We don't want to handle your money directly, so we've connected your bank account to our payment gateway. Payments are processed instantly on your behalf, automatically splitting the amount into:\n1) product fee,\n2) payment provider fee, and\n3) your earnings.\nEveryone receives immediate access to their cleared balance, depending on the chosen payment method.",
          label: 'connect-your-bank',
        },
        {
          title: 'Choose your pay day',
          text: 'Schedule payouts as often as you need. We understand that healthy cash flow is essential for efficient production.',
          label: 'choose-your-pay-day',
        },
        {
          title: 'Control your refunds and cancellations',
          text: "With full control over your ticket balance, you never have to wait to issue refunds. From now on, you'll have instant insights into cancellations and detailed information about every transaction.\nNO, from now on you have all the control!",
          label: 'control-your-refunds',
        },
      ],
      statistics: [
        {
          title: 'Connect any online tracking',
          text: 'GTM is fully integrated with our own internal tagging system. Enrich your audience database by leveraging every feature Google Tag Manager offers, plus additional internal tags for products or your shop. Easily organize your database by interests or buying behavior—such as artist names, ticket types, purchase values, or specific product choices—to optimize your marketing strategy.',
          label: 'connect-online-tracking',
        },
        {
          title: 'Customize your data requirements for shop sales',
          text: 'Easily add custom fields to your info form—such as yes/no, multiple-choice (ABC), or open-ended questions.',
          label: 'customize-your-data',
        },
        {
          title: 'Activate buyer login',
          text: "We collect valuable data, such as previous purchases, preferred sales channels, and buying patterns (e.g., early-bird buyers). By activating buyer profiles, you'll gain clear, actionable insights into your customers.",
          label: 'activate-buyer-login',
        },
        {
          title: 'Create member login for loyalty and communication',
          text: 'Offer your customers their own login area, providing a convenient overview of all purchases and a space to update personal data or request support. You can also reward members through loyalty programs like early access to sales or personalized offers.',
          label: 'create-member-login',
        },
        {
          title: 'Publish your own fan-base application',
          text: 'Another powerful solution we offer is our white-label app, WE-DO—a personalized community-building platform and dedicated communication channel, tailored specifically to your needs and those of your customers.',
          label: 'publish-your-fan-base',
        },
      ],
      settings: [
        {
          title: 'Easy login by TEAMS',
          text: 'Our accreditation app is versatile yet easy to set up. Quickly create teams with secure logins (QR or password) and assign custom permissions per user to track individual analytics. Easily manage access levels—from purchase validation only to viewing live statistics. With our integrated POS feature, you can even sell and validate simultaneously.',
          label: 'easy-login-teams',
        },
        {
          title: 'Sell and scan at the same time at the same device',
          text: 'The integrated POS feature lets you effortlessly sell and validate tickets (or products) using the same device and app—just swipe directly from the screen.',
          label: 'sell-and-scan',
        },
        {
          title: 'Online and offline scanning',
          text: 'No internet or stuck with a weak connection (1G/2G)? No worries—simply set up your scanners in advance and create an internal Wi-Fi network to sync seamlessly between devices.',
          label: 'online-and-offline-scanning',
        },
        {
          title: 'Use any brand of device',
          text: 'IOS/OS ANDROID/GOOGLE, Huawei, MICROSOFT, Linux.',
          label: 'use-any-device',
        },
        {
          title: 'Live statistics',
          text: 'Access your data anytime—directly through the app (once set up) or online with an internet connection. With an impressive scan rate (multiple devices syncing in seconds, even on minimal connections), your stats update instantly, keeping you effortlessly informed.',
          label: 'live-statistics',
        },
        {
          title: 'Role management',
          text: 'Easily manage roles and permissions across different teams. Control who sees statistics—and to what extent—whether per device, entrance, or ticket type. Everything is customizable through our TEAMS setup.',
          label: 'role-management',
        },
      ],
      dashboard: [
        {
          title: 'Control your secondary ticketing yourself',
          text: 'By locking your QR code, you gain access to our internal Secondary Ticketing System, featuring options like partial refunds, loyalty refunds, and guaranteed refunds (full or percentage-based).',
          label: 'controle-your-secondary-ticketing',
        },
        {
          title: 'Control who can by what at what moment',
          text: 'Reward your loyal fans with early access or share exclusive deals with your "friends-only WhatsApp group," without compromising trust among other customers.',
          label: 'control-who-can-at-moment',
        },
        {
          title: 'Control who can sell at what price, on what channel',
          text: 'Whether through POS, secure or open online links, invites, or guest lists—manage everything effortlessly by creating Multiple Links in our system.',
          label: 'control-who-can-sell',
        },
        {
          title: 'Control your cashflow and invoice model',
          text: "It's your money, not ours. We have a zero-touch policy.",
          label: 'control-your-cashflow',
        },
        {
          title: 'Control your "product / company" no it should hold you back',
          text: "We're always looking to add new features and improvements—and there's no better judge than you! Let us know what's missing or what you'd like added, and together we'll make it happen.",
          label: 'control-your-product',
        },
      ],
    },
    loginModal: {
      title: 'Choose your Dashboard for your Event',
      enterDashboard: 'ENTER DASHBOARD',
      launch: {
        title: 'Launch',
        link: 'http://dev-tapp.sixtix.com/login',
        phrase: 'Go live in minutes. No hassle',
        features: [
          'Direct access to ticket marketplace',
          'Guestlist & invite management',
          'Pre-registration forms',
          'Festivals, nightlife, community events, pop-ups.',
        ],
        description:
          'Event creators who want to publish tickets quickly and gain immediate market access.',
      },
      control: {
        title: 'Control',
        link: `https://app.sixtix.com/login`,
        phrase: 'Your venue. Your audience. Your rules',
        features: [
          'Seated ticketing & venue mapping',
          'Membership access & loyalty features',
          'Direct ticket offers to buyers (B2C)',
          'Sport events, seated shows, clubs with members, theaters.',
        ],
        description:
          'Organizers working with seated layouts, memberships, or direct customer communication.',
      },
      pro: {
        title: 'Pro',
        link: '/',
        phrase: '',
        features: [
          'Advanced analytics & insights',
          'Custom drag & drop interface',
          'Shop-in-shop: sell tickets & more',
          'Multi-ebvent organizers, brands, agencies, high-end experiences.',
        ],
        description:
          'Organizers focused on data, branding, and additional revenue opportunities.',
      },
    },
    acceptation: {
      title:
        'We willen en kunnen niks zonder jouw toestemming doen! Transparant & eerlijk, dat is waar we voor staan.',
      'I accept ': 'Ik accepteer ',
      submit: 'Activeer mijn account',
    },
  },
  rs: {
    common: {
      lostTicket: 'Izgubili ste kartu?',
      login: 'Login',
      contact: 'Kontakt',
      policy: 'Politika Privatnosti',
      terms: 'Uslovi korišćenja usluge',
      cookie: '',
      learnMore: 'Saznajte više',
      knowledgeBtn: 'Baza znanja',
      ourPartnerships: 'Naši partneri',
    },
    hero: {
      title: 'Vaša puna kontrola u prodaji karata',
      description:
        'Jedinstvena platforma za prodaju karata — povežite se sa svojom publikom, pratite prodaju u realnom vremenu i naplatite sve bez komplikacija.',
      features: 'Lako podešavanje - Efikasna prodaja - Trenutno plaćanje',
      requestDemo: 'Zahtevajte demo',
    },
    asEasyAs: {
      title: 'Jednostavno kao',
      sell: {
        title: 'Prodaja',
        text: 'Objedinjeni sistem koji vam pruža sve alate koji su vam potrebni. Prodajte bilo šta, bilo kada i bilo gde – na mreži putem vašeg veb-sajta ili društvenih mreža, ili lično putem POS aplikacije. Od ulaznica i proizvoda do rezervacija i čak mesečnih pretplata – sve je moguće.',
      },
      collect: {
        title: 'Naplata',
        text: 'Znamo da je tok gotovine ključan za uspeh vašeg poslovanja. Zato smo povezali vaš bankovni račun direktno sa vašom prodavnicom i primenili našu poslovnu politiku kojom je definisano da nemamo pristup vašem novcu. Svaka uplata se odmah deli na vašu zaradu, našu proviziju i transakcioni trošak platnog procesora – jednostavno i transparentno.',
      },
      monetize: {
        title: 'Monetizacija',
        text: 'Verujemo u moć vaših podataka, zbog čega smo razvili niz funkcija za maksimizaciju dobiti i kreiranje dodatnih izvora prihoda za vaše krajnje korisnike (kupce ulaznica). Naša vizuelno neutralna aplikacija za zajednicu sa vašim brendiranjem olakšava dodatnu prodaju i besprekorno se integriše sa sponzorstvima trećih strana i marketinškim kampanjama.',
      },
    },
    yourSix: {
      title: 'Šest ključnih funkcija SIXTIX-a',
      shop: {
        title: 'Prodavnica',
        text1: 'Kreirajte ',
        text2: ' prodavnicu',
        your: 'SVOJU',
        tooltip:
          '„Od prilagođavanja boja i zahteva, do ponude popusta kupcima – bilo da vam treba numerisano sedište ili rezervacije, mi imamo rešenje.“',
      },
      marketing: {
        title: 'Marketing',
        text1: 'Prodajte ',
        text2: ' proizvode',
        your: 'SVOJE',
        tooltip:
          '„Jednostavno sveobuhvatno upravljanje pomoću telefona, veb-sajta ili sopstvene aplikacije. Postavite sve brzo putem ličnog kontrolnog panela sa punom kontrolom šta, kada, gde i kome prodajete.“',
      },
      finance: {
        title: 'Finansije',
        text1: 'Primite ',
        text2: ' novac',
        your: 'SVOJ',
        tooltip:
          '„Zahvaljujući našoj politici da je vaš novac van našeg dostupa, vi imate potpunu kontrolu podešavanja koja se odnose na vaš tok gotovine.“',
      },
      statistics: {
        title: 'Statistika',
        text1: 'Razvijte ',
        text2: ' bazu podataka',
        your: 'SVOJU',
        tooltip:
          '„Vaša aktivna baza podataka je vaše najveće bogatstvo –počnite da je koristite na pravi način!“',
      },
      settings: {
        title: 'Postavke',
        text1: 'KONTROLIŠITE',
        your: 'VAŠE',
        text2: 'ULAZE',
        tooltip:
          '„Kreiranje izuzetne vrednosti za klijenta počinje pružanjem izuzetne usluge.“',
      },
      dashboard: {
        title: 'Kontrolni panel',
        text1: 'VI',
        your: 'PREUZMITE',
        text2: 'KONTROLU',
        tooltip: '„Zavisnost od pružaoca usluga je prošlost!“',
      },
    },
    takingBackControl: {
      title: 'Potpuna kontrola podataka!',
      slider: 'GLOBALNI KLIZAC ZA FEED NOVINA',
    },
    agenda: {
      title: 'Naredni događaji',
      showMore: 'Pokaži više',
      tickets: 'Ulaznice',
      startDate: 'Datum početka',
      endDate: 'Datum završetka',
    },
    about: {
      title: 'Šta želite da znate o nama?',
      sectionsList: [
        {
          title: 'FAQ SIXTIX',
          subsections: [
            {
              title: 'Kako da koristim SIXTIX?',
              text: 'Jednostavno se prijavite i kreirajte svoj nalog kao prodavac, kupac ili posrednik u prodaji – i počnite da kreirate svoje događaje. SIXTIX olakšava kreiranje, upravljanje i promociju vaših događaja. Od i-mejl marketinga do integracije sa društvenim mrežama, otkrićete napredne alate koji su dizajnirani da vam pomognu da prodate više ulaznica i razvijate poslovanje – i sve to na jednom mestu.',
            },
          ],
        },
        {
          title: 'KONTROLNI PANEL ZA ULAZNICE',
          subsections: [
            {
              title: 'Kako da kreiram više tipova ulaznica na SIXTIX-u?',
              text: 'SIXTIX vam omogućava da lako kreirate različite tipove ulaznica, kao što su Pretprodaja ili VIP, sa optimizacijom prodaje na mreži, namenjene kupcima sa različitim budžetima i time ostvarite veći obim prodaje.',
            },
            {
              title:
                'Gde mogu da pronađem podršku koja mi može pomoći u prodaji?',
              text: 'U sekciji „Podrška“ na kontrolnom panelu.',
            },
            {
              title:
                'Gde mogu da pronađem podatke o posetiocima i prodajnu statistiku?',
              text: 'U sekciji „Prodaja“ (statistika), podaci o prodaji mogu se naći u okviru statistika o prodaji. Takođe, mogu se preuzeti na stranici „Izveštaji“.',
            },
            {
              title: 'Mogu li da ponudim ulaznice sa specijalnim cenama?',
              text: 'Možete distribuirati bilo koju ulaznicu sa specijalnom cenom putem vaše interne prodavnicu.',
            },
            {
              title:
                'Da li nudite posebne cene usluge za neprofitne organizacije?',
              text: 'Da, nudimo snižene naknade za prodaje ulaznica od kojih se finansiraju donacije, tako da još veći deo sredstava direktno podržava vašu misiju. Posvećeni smo podršci neprofitnim organizacijama sa funkcijama dizajniranim da pomognu vama i vašoj zajednici da napredujete.',
            },
            {
              title: 'Šta su Zaključane ulaznice?',
              text: 'Zaključane ulaznice su ulaznice koje postaju dostupne za preuzimanje neposredno pre početka događaja. Obezbeđujemo ih na zahtev organizatora kako bismo sprečili prevaru i obeshrabrili nepravednu trgovinu ulaznicama.',
            },
            {
              title: 'Moja prodavnica ulaznica više nije aktivna. Šta sada?',
              text: 'Proverite da li su vreme i datum događaja ispravno postavljeni. To možete uraditi putem „Stranice događaja“, uređivanjem podataka o događaju. Proverite da li je događaj još uvek aktivan. To možete uraditi na „Stranici događaja“, „Uredi podatke o događaju“.',
            },
            {
              title:
                'Moje ulaznice više nisu vidljive u prodavnici ulaznica. Šta sada?',
              text: 'Proverite u opcijama ulaznice da li su datum i vreme ulaznice ispravno postavljeni. To možete uraditi putem „Stranice ulaznica“.',
            },
            {
              title:
                'Zaustavljanje prodaje / deaktiviranje prodavnice ulaznica',
              text: 'Možete (privremeno) zaustaviti prodaju ulaznica za događaj. Idite na „Stranicu događaja“.',
            },
            {
              title: 'Želim da prodajem grupne ulaznice',
              text: 'Kreirajte ulaznicu putem „Stranice ulaznica“ i navedite naziv grupne ulaznice, ukupni kapacitet svih grupnih ulaznica koje želite da prodate, i ukupnu cenu grupne ulaznice.',
            },
            {
              title: 'Slanje ulaznica za spisak zvanica',
              text: 'Putem „Interne prodavnice“, interna prodavnica omogućava distribuciju bilo koje ulaznice sa bilo kojom cenom.',
            },
            {
              title: 'Želim da povećam/smanjim kapacitet prodaje ulaznica',
              text: 'Idite na „Stranicu ulaznica“.',
            },
            {
              title: 'Želim da dodam dodatnu/drugačiju ulaznicu tokom prodaje',
              text: 'Idite na „Stranicu događaja“.',
            },
            {
              title: 'Želim da povučem ulaznicu iz prodaje',
              text: 'Idite na „Stranicu događaja“.',
            },
            {
              title:
                'Pored ulaznica, želim da prodajem kovanice, karte za parking, robu i slično.',
              text: 'Možete kreirati dodatnu ulaznicu za ovo na „Stranici ulaznica“.',
            },
          ],
        },
        {
          title: 'ULAZNICE I SKENIRANJE',
          subsections: [
            {
              title: 'Kako da skeniram ulaznice?',
              text: 'Za skeniranje ulaznica koristite SIXTIX-ovu aplikaciju za skener. Možete je preuzeti i instalirati na svom pametnom telefonu.',
            },
            {
              title:
                'Kupac ulaznice nije dobio ulaznicu a platio je. Šta da radim?',
              text: 'Možete da pronađete kupca na stranici „Transakcije“ i ponovo pošaljete njegove ulaznice ili izmenite njegov i-mejl i ponovo ih pošaljete.',
            },
            {
              title: 'Prijava u aplikaciji za skener.',
              text: 'Možete skenirati ulaznice putem SIXTIX-ove aplikacije za skener. Prijavite se sa svojim korisničkim imenom + šifrom ili putem QR koda. Ako ne želite da delite svoje korisničko ime + šifru sa timom za skeniranje na ulazu, možete kreirati QR kod za prijavu putem „Stranice tima“.',
            },
            {
              title: 'Problemi sa prijavljivanjem na aplikaciju za skener',
              text: 'Koristite isto korisničko ime + šifru kao za nalog. QR kod za prijavljivanje može se kreirati u nalogu. Idite na „Stranicu tima“, izaberite događaj i ulaznice, sačuvajte ih. QR kod se može koristiti za prijavu u aplikaciju za skener.',
            },
            {
              title:
                'Posetilac na ulazu je platio, ali nema ulaznicu. Šta sada?',
              text: 'U aplikaciji za skener možete pretražiti kupca ulaznice po imenu ili i-mejl adresi putem lupe za pretragu i skenirati ulaznice. Svi podaci o prodaji mogu se naći na „Stranici transakcija događaja“. Ulaznice se mogu ponovo poslati putem „Stranice transakcija događaja“.',
            },
            {
              title: 'Ulaznice nije moguće skenirati.',
              text: 'Da li posetilac ima važeću ulaznicu? Da biste to proverili, ulaznicu možete pronaći na „Stranici transakcija događaja“.',
            },
            {
              title: 'Podaci o rezultatima skeniranja',
              text: 'Mogu se videti u aplikaciji, ali i putem kontrolnog panela na „Stranici transakcije događaja“.',
            },
            {
              title:
                'Da li su telefon ili skener povezani sa internetom? Da li je izabran ispravan događaj?',
              text: '',
            },
          ],
        },
        {
          title: 'KUPAC ULAZNICA',
          subsections: [
            {
              title: 'Kako da kupim ulaznice putem vašeg servisa?',
              text: 'Ulaznice možete kupiti posetom našem sajtu. Jednostavno izaberite događaj koji vas zanima, izaberite željenu ulaznicu i nastavite do naplate.',
            },
            {
              title: 'Mogu li se ulaznice skenirati sa mog telefona?',
              text: 'Da, mogu.',
            },
            {
              title: 'Kako da dodam ulaznicu ili karticu u virtuelni novčanik?',
              text: 'Da biste dodali ulaznicu ili karticu u svoj virtuelni novčanik, pritisnite dugme „Dodaj u novčanik“ u i-mejlu sa potvrdom kupovine.',
            },
            {
              title: 'Da li je funkcija „Dodaj u novčanik“ bezbedna?',
              text: 'Da, dodavanje stavki u vaš novčanik je generalno bezbedno. Aplikacije za novčanik koriste enkripciju i bezbedne protokole da bi zaštitile vaše podatke. Uvek koristite zvanične aplikacije i platforme kako biste bili bezbedni.',
            },
            {
              title: 'Mogu li da koristim sadržaj iz novčanika i van mreže?',
              text: 'Da, mnoge stavke u novčaniku, kao što su ulaznice, mogu se koristiti van mreže nakon što su dodate. Međutim, neke ulaznice, kao što su sezonske ili u realnom vremenu, mogu zahtevati internet konekciju.',
            },
            {
              title: 'Moje ulaznice su zaključane',
              text: 'Ako ste kupili ulaznice za događaj, možda ste primetili da su neke ulaznice označene kao „zaključane“. To znači da će ulaznice biti dostupne za preuzimanje tek uoči događaja. Organizatori koriste Zaključane ulaznice kako bi sprečili prevaru i obeshrabrili nepravednu trgovinu ulaznicama. Ulaznice će obično biti dostupne nekoliko dana pre događaja.',
            },
            {
              title: 'Gde mogu da zahtevam povrat novca?',
              text: 'Pošaljite zahtev promoteru/organizatoru.',
            },
            {
              title: 'Kada mogu da očekujem povrat novca?',
              text: 'Kada morate da zatražite povrat novca, vaš novac je odmah dostupan na vašem računu nakon validacije.',
            },
            {
              title: 'Ulaznice nisu primljene.',
              text: 'Pošaljite zahtev promoteru/organizatoru.',
            },
            {
              title: 'Nisam dobio potvrdu putem i-mejla.',
              text: 'Kontaktirajte organizatora sa identifikacionim brojem vaše transakcije radi validacije, organizator ima mogućnost da vašu ulaznicu ponovo pošalje na ispravan i-mejl.',
            },
            {
              title: 'Personalizacija ulaznica',
              text: 'Ako je potrebna personalizacija, biće zatražena tokom procesa kupovine.',
            },
            {
              title: 'Moja ulaznica je nevažeća ili otkazana.',
              text: 'Ako primetite da su vaše ulaznice označene kao nevažeće ili otkazane, to znači da one više neće biti važeće za ulazak na događaj. Ulaznice mogu biti poništene ili otkazane iz različitih razloga.',
            },
            {
              title: 'Moja uplata je otkazana.',
              text: 'Nažalost, vaša narudžbina je otkazana. Vaše ulaznice nisu rezervisane, stoga nemate važeće ulaznice za događaj. Možete pokušati da izvršite novu narudžbinu nekim drugim načinom plaćanja.',
            },
          ],
        },
      ],
    },
    yourSixElements: {
      shop: [
        {
          title:
            'Vizuelno neutralna platforma koju je u potpunosti moguće brendirati za vas',
          text: 'Vaš brend je veza između vas i kupaca, i mi to shvatamo ozbiljno. Sve, od podataka neophodnih za kupovinu do boja vaše prodavnice i procesa kupovine, može biti prilagođeno vašem brendu.',
          label: 'full-white-label',
        },
        {
          title: 'Sve vrste prodavnica su dostupne',
          text: 'Mesta za sedenje, termini, proizvodi, klasične ulaznice, sezonske ulaznice, članstva, rezervacije ili pretprodaja. Vi bolje poznajete svoj proizvod nego mi. Mi se fokusiramo na pokrivanje svih mogućnosti uz jednostavne i intuitivne korake za korisnika.',
          label: 'all-type-of-shop',
        },
        {
          title: 'Bezbedno korisničko iskustvo',
          text: 'Unapredite sam događaj višim nivoom kvaliteta uz najnoviju dostupnu tehnologiju. Naša besprekorna integracija sa Apple Wallet-om i Google Wallet-om omogućava brz i lak pristup ulaznicama. Zaštitite sekundarno tržište dinamičkim QR kodovima ili, ako želite luksuznije rešenje, koristite naše zaštićeno NFC rešenje za fizičke kartice.',
          label: 'secured-costumer',
        },
        {
          title: 'Personalizovana komunikacija',
          text: 'Otvorite direktan komunikacioni kanal sa svojim kupcima i članovima putem sistema prijave kupaca/članova. To nije samo funkcija za čet – korisnici će imati jasan pregled svojih kupovina, ekskluzivne ponude 1-na-1 i rani pristup ulaznicama ili proizvodima koji iznenada postanu dostupni.',
          label: 'personal-contact',
        },
        {
          title:
            'Više prodavnica u jednoj (praćenje, pozivnice, popusti, zaštita)',
          text: 'Razumemo potrebe prodaje, zato smo razvili fleksibilan i prilagodljiv sistem. Pratite prodaju putem različitih linkova i poboljšajte marketinške kampanje. Omogućite sponzorima posebne pristupe (linkovi sa popustima), distribuirajte domaćinima dodatne ulaznice za spisak zvanica. Omogućite prodaju preko ambasadora na terenu. Sve je to moguće. Ako imate specifičan način prodaje koji naš softver trenutno ne podržava, spremni smo da zajedno pronađemo rešenje.',
          label: 'multiple-shops',
        },
      ],
      marketing: [
        {
          title: 'Direktan skraćeni link',
          text: 'Razumemo vas, vreme je dragoceno. Zato vam nije potreban shorturl.com –samo unesite svoju jedinstvenu referencu u okruženju za kreiranje linka: sixtix.com/reference.',
          label: 'direct-short-link',
        },
        {
          title:
            'Iframe integracija na bilo koji sajt (potpuno prilagođeno mobilnim uređajima)',
          text: 'Kreirajte dugme za kupovinu ulaznica bilo gde – van mreže putem QR koda ili na mreži pomoću iframe-a. Postavite ga jednom i zaboravite na brige – sistem je potpuno prilagodljiv i automatski se sinhronizuje sa vašim podešavanjima za dati događaj.',
          label: 'iframe-integration',
        },
        {
          title: 'POS aplikacija za prodaju',
          text: 'Kada kažemo da možete prodavati bilo gde, zaista mislimo bilo gde – ne samo na mreži. Preuzmite našu akreditacionu aplikaciju sa ugrađenom POS funkcionalnošću i prodajte bilo koji proizvod putem QR kodova, platnih linkova ili Tap2Pay opcije (prihvata Apple Pay, Google Pay i fizičke kartice).',
          label: 'pos-integration',
        },
      ],
      finance: [
        {
          title: 'Izaberite opcije plaćanja na mreži',
          text: 'Ako vaš željeni metod plaćanja nije dostupan, javite nam se – integrišemo ga za vas!',
          label: 'choose-online-payment-options',
        },
        {
          title: 'Povežite Tap2Pay sa POS aplikacijom',
          text: 'Pretvorite bilo koji Android ili iOS uređaj u lokalni terminal za plaćanje, direktno povezan sa POS funkcionalnošću unutar naše akreditacione aplikacije.',
          label: 'connect-tap2pay-pos',
        },
        {
          title:
            'Povežite bankovni račun sa virtuelnim novčanikom (podela iznosa plaćanja)',
          text: 'Ne želimo da upravljamo vašim novcem direktno, zato smo povezali vaš bankovni račun sa našim mrežnim prolazom za plaćanje. Plaćanja se odmah obrađuju u vaše ime i automatski dele na: 1) cenu proizvoda, 2) proviziju platnog procesora, 3) vašu zaradu.\nSvi odmah dobijaju pristup raspoloživom saldu, u zavisnosti od odabranog načina plaćanja.',
          label: 'connect-your-bank',
        },
        {
          title: 'Izaberite dan isplate',
          text: 'Podesite isplate onoliko često koliko vam je potrebno. Znamo koliko je zdrav tok gotovine važan za uspešnu realizaciju događaja.',
          label: 'choose-your-pay-day',
        },
        {
          title: 'Kontrolišite refundacije i otkazivanja',
          text: 'Uz punu kontrolu nad svojim budžetom, više ne morate čekati na refundacije. Sada imate trenutni uvid u otkazivanja i detaljne informacije o svakoj transakciji.\nNE, od sada VI imate potpunu kontrolu!',
          label: 'control-your-refunds',
        },
      ],
      statistics: [
        {
          title: 'Povežite bilo koji mrežni sistem za praćenje',
          text: 'GTM je potpuno integrisan sa našim internim sistemom za tagovanje. Obogatite svoju bazu podataka koristeći sve prednosti Google Tag Managera, uz dodatne interne tagove za proizvode ili prodavnicu. Lako organizujte podatke po interesovanjima i kupovnim navikama – npr. imena izvođača, tipovi ulaznica, ulaznica, ine ili konkretni proizvodi – i optimizujte svoju marketinšku strategiju.',
          label: 'connect-online-tracking',
        },
        {
          title: 'Prilagodite podatke za prodaju u svojoj prodavnici',
          text: 'Jednostavno dodajte prilagođena polja u info formular – bilo da su tipa da/ne, višestruki izbor (ABC) ili otvorena pitanja.',
          label: 'customize-your-data',
        },
        {
          title: 'Aktivirajte funkciju prijavljivanja za kupce',
          text: 'Prikupljamo vredne podatke poput prethodnih kupovina, željenih kanala prodaje i obrazaca kupovine (npr. kupci u pretprodaji). Aktiviranjem profila kupaca dobijate jasne i korisne uvide u njihovo ponašanje.',
          label: 'activate-buyer-login',
        },
        {
          title:
            'Kreirajte funkciju profila članova za programe lojalnosti i komunikaciju',
          text: 'Omogućite kupcima pristup ličnom profilu sa pregledom kupovina, mogućnošću ažuriranja podataka ili pristupa podršci. Takođe, možete ih nagraditi programom lojalnosti, pogodnostima poput ranog pristupa prodaji ili personalizovanih ponuda.',
          label: 'create-member-login',
        },
        {
          title: 'Objavite sopstvenu aplikaciju za bazu fanova',
          text: 'Nudimo moćno rešenje – našu nebrendiranu aplikaciju WE-DO, specijalno za vas dizajniranu za izgradnju zajednice i direktnu komunikaciju sa vašim kupcima, prilagođenu samo vašim potrebama i potrebama vaših kupcima.',
          label: 'publish-your-fan-base',
        },
      ],
      settings: [
        {
          title: 'Jednostavno prijavljivanje putem TEAMS platforme',
          text: 'Naša akreditaciona aplikacija je moćna, ali jednostavna za podešavanje. Brzo kreirajte timove sa bezbednom prijavom (QR kod ili lozinka) i dodelite korisnicima prilagođene dozvole za praćenje analitike. Upravljajte pristupnim nivoima – od validacije kupovine do pregleda statistike uživo. Uz pomoć naše integrisane POS funkcije, možete istovremeno prodavati i vršiti validaciju.',
          label: 'easy-login-teams',
        },
        {
          title: 'Prodaja i skeniranje u isto vreme, na istom uređaju',
          text: 'Integrisana POS funkcionalnost omogućava vam da istovremeno prodajete i validirate ulaznice (ili proizvode) na istom uređaju – samo prevucite prstom po ekranu.',
          label: 'sell-and-scan',
        },
        {
          title: 'Skeniranje na mreži i van mreže',
          text: 'Nema interneta ili je spor (1G/2G)? Nema problema – podesite skenere unapred i kreirajte internu Wi-Fi mrežu za sinhronizaciju između uređaja.',
          label: 'online-and-offline-scanning',
        },
        {
          title: 'Kompatibilnost sa bilo kojim uređajem',
          text: 'Apple iOS, Google Android OS, Huawei HarmonyOS, Microsoft Windows, Linux OS.',
          label: 'use-any-device',
        },
        {
          title: 'Statistika u realnom vremenu',
          text: 'Pristupite podacima u svakom trenutku – direktno putem aplikacije (posle inicijalnog podešavanja) ili na mreži. Brzina skeniranja je impresivna (više uređaja se sinhronizuje u sekundama, čak i na sporoj vezi), tako da su vaši podaci uvek ažurirani a vi informisani bez dodatnog napora.',
          label: 'live-statistics',
        },
        {
          title: 'Upravljanje ulogama',
          text: 'Jednostavno upravljajte korisničkim pravima i dozvolama u različitim timovima. Kontrolišite ko vidi statistiku i u kojoj meri – bilo po uređaju, ulazu ili tipu ulaznice. Sve je prilagodljivo kroz podešavanja naše TEAMS platforme.',
          label: 'role-management',
        },
      ],
      dashboard: [
        {
          title: 'Kontrolišite sekundarnu prodaju ulaznica',
          text: 'Zaključavanjem QR koda dobijate pristup našem internom sistemu za sekundarnu prodaju, sa opcijama delimičnih refundacija, refundacija u okviru programa lojalnosti i garantovanih refundacija (potpune ili procentualne).',
          label: 'controle-your-secondary-ticketing',
        },
        {
          title: 'Kontrolišite ko može da kupi šta i kada',
          text: 'Nagradite lojalne fanove ranijim pristupom ili delite ekskluzivne ponude u privatnim WhatsApp grupama, bez narušavanja poverenja drugih kupaca.',
          label: 'control-who-can-at-moment',
        },
        {
          title:
            'Kontrolišite ko može da prodaje, po kojoj ceni i kojim kanalom prodaje',
          text: 'Bilo da je prodaja putem POS-a, bezbednih ili otvorenih linkova na mreži, pozivnica ili spiska zvanica – upravljajte svime bez napora uz kreiranje više prodajnih linkova unutar našeg sistema.',
          label: 'control-who-can-sell',
        },
        {
          title: 'Kontrolišite novčane tokove i fakturisanje',
          text: 'Novac je vaš a ne naš. Mi imamo politiku poslovanja bez pristupa vašem novcu, što znači da ne upravljamo vašim novcem.',
          label: 'control-your-cashflow',
        },
        {
          title:
            'Kontrolišite razvoj svojih proizvoda i kompanije – IT ne treba da vas ograničava!',
          text: 'Konstantno unapređujemo platformu i dodajemo funkcionalnosti, a najbolji vodič su upravo vaše potrebe. Recite nam šta vam nedostaje ili šta biste želeli da dodamo – zajedno ćemo pronaći rešenje.',
          label: 'control-your-product',
        },
      ],
    },
    loginModal: {
      title: 'Choose your Dashboard for your Event',
      enterDashboard: 'ENTER DASHBOARD',
      launch: {
        title: 'Launch',
        link: 'https://dev-tapp.sixtix.nl/login',
        phrase: 'Go live in minutes. No hassle',
        features: [
          'Direct access to ticket marketplace',
          'Guestlist & invite management',
          'Pre-registration forms',
          'Festivals, nightlife, community events, pop-ups.',
        ],
        description:
          'Event creators who want to publish tickets quickly and gain immediate market access.',
      },
      control: {
        title: 'Control',
        link: `https://app.sixtix.com/login`,
        phrase: 'Your venue. Your audience. Your rules',
        features: [
          'Seated ticketing & venue mapping',
          'Membership access & loyalty features',
          'Direct ticket offers to buyers (B2C)',
          'Sport events, seated shows, clubs with members, theaters.',
        ],
        description:
          'Organizers working with seated layouts, memberships, or direct customer communication.',
      },
      pro: {
        title: 'Pro',
        link: '/',
        phrase: '',
        features: [
          'Advanced analytics & insights',
          'Custom drag & drop interface',
          'Shop-in-shop: sell tickets & more',
          'Multi-ebvent organizers, brands, agencies, high-end experiences.',
        ],
        description:
          'Organizers focused on data, branding, and additional revenue opportunities.',
      },
    },
    acceptation: {
      title:
        'We willen en kunnen niks zonder jouw toestemming doen! Transparant & eerlijk, dat is waar we voor staan.',
      'I accept ': 'Ik accepteer ',
      submit: 'Activeer mijn account',
    },
  },
  fr: {
    common: {
      lostTicket: 'Lost your Ticket?',
      login: 'Login',
      contact: 'Contact',
      policy: 'Privacy Policy',
      terms: 'Terms of Service',
      cookie: 'Cookie Statement',
      learnMore: 'Learn More',
      knowledgeBtn: 'Knowledge base',
      ourPartnerships: 'Our loyal Partnerships',
    },
    hero: {
      title: 'Your full control in ticketing',
      description:
        'A single platform where you can manage all your commerce. Connect with your audience easily, sell your products efficiently, and collect your payments instantly.',
      features: 'Easy setup - Efficient sales - Instant payment',
      requestDemo: 'Request demo',
    },
    asEasyAs: {
      title: 'It’s as easy as',
      sell: {
        title: 'Sell',
        text: 'One system, that will give you all the tools you need. Sell anything you want, whenever and wherever you like. Online through your website or social channels, or in-person using POS application. From tickets and products to reservations and even monthly subscriptions —everything is possible.',
      },
      collect: {
        title: 'Collect',
        text: 'We know cash flow is essential to your business success. That`s why we`ve connected your bank account directly to your store with our zero-touch policy. Every payment is instantly split into your earnings, our product fee, and the payment provider`s transaction fee—simple and transparent.',
      },
      monetize: {
        title: 'Monetize',
        text: 'We believe in the power of your data, therefor we developed several features to maximize your profits and create additional revenue streams for your end-users (ticket buyers). Our white-label community app makes upselling events easy and integrates seamlessly with third-party sponsorships and marketing campaigns.',
      },
    },
    yourSix: {
      title: 'Your six of SIXTIX',
      shop: {
        title: 'Shop',
        text1: 'CREATE ',
        text2: ' SHOP',
        your: 'YOUR',
        tooltip:
          "”From customizing colors and requirements to offering buyer discounts—whether you need assigned seating or reservations, we've got you covered.”",
      },
      marketing: {
        title: 'Marketing',
        text1: 'SELL ',
        text2: ' PRODUCTS',
        your: 'YOUR',
        tooltip:
          '“Manage everything easily from your phone, website, or own application. Set it up quickly via your personal dashboard, giving you full control over what, when, where, and who.”',
      },
      finance: {
        title: 'Finance',
        text1: 'GET ',
        text2: ' MONEY',
        your: 'YOUR',
        tooltip:
          '“With our zero-touch money policy, you have direct control over all your cash flow settings.”',
      },
      statistics: {
        title: 'Statistics',
        text1: 'GROW ',
        text2: ' DATABASE',
        your: 'YOUR',
        tooltip:
          '“Your active database is your greatest asset—start leveraging it!”',
      },
      settings: {
        title: 'Settings',
        text1: 'CONTROL ',
        text2: ' ENTRANCE',
        your: 'YOUR',
        tooltip: '“Great customer value starts with great service.”',
      },
      dashboard: {
        title: 'Dashboard',
        text1: 'GET ',
        text2: ' CONTROL',
        your: 'YOUR',
        tooltip: '”The days of depending on your provider are over!”',
      },
    },
    takingBackControl: {
      title: 'Taking back Control!',
      slider: 'GLOBAL NEWSFEED SLIDER',
    },
    agenda: {
      title: 'Agenda',
      showMore: 'Show more',
      tickets: 'Tickets',
      startDate: 'Start date',
      endDate: 'End date',
    },
    about: {
      title: 'What do you want to know about us?',
      sectionsList: [
        {
          title: 'FAQ SIXTIX',
          subsections: [
            {
              title: 'How do I use SIXTIX?',
              text: 'Just sign up to create your account as a seller, buyer or reseller — and then start creating your events. SIXTIX makes it easy to create, manage, and promote your events. From email marketing to social media integration, you’ll discover advanced tools designed to help you sell more tickets and grow your business all in one place.',
            },
          ],
        },
        {
          title: 'TICKET DASHBOARD',
          subsections: [
            {
              title: 'How do I create multiple ticket types on SIXTIX?',
              text: 'With SIXTIX, you can easily create multiple ticket types such as Early Bird or VIP, optimizing your online sales by appealing to different budgets and encouraging more ticket purchases.',
            },
            {
              title: 'Where can I find support that can help me with sales?',
              text: 'Under the heading "Support" in your dashboard.',
            },
            {
              title: 'Where can I find visitor data and sales insights?',
              text: 'Under sales (statistics), data can be found on sales statistics. And downloadable on the “Report page”.',
            },
            {
              title: 'Can I offer special prize tickets?',
              text: 'You can send out any ticket with a special prize through your internal shop.',
            },
            {
              title: 'Do you offer special pricing for nonprofits?',
              text: 'Yes, we offer discounted Ticketing Fees on donation tickets, so more of your funds go directly to your cause. We’re committed to supporting non-profits with tailored features designed to help you and your community thrive.',
            },
            {
              title: 'What are Sealed Tickets?',
              text: 'Sealed Tickets are tickets that become available for download shortly before an event starts. We do this at the organizer’s request to prevent fraud and discourage unfair trading of tickets.',
            },
            {
              title: 'My ticket shop is no longer active. What now?',
              text: 'Check if the time and date of the event are set correctly. You do this via “Event page”, edit event. Check if the event is still active. You do this via “Event page”, edit event.',
            },
            {
              title:
                'My tickets are no longer visible in the ticket shop. What now?',
              text: 'Check in the options of the ticket whether the ticket date and time are set correctly. You do this via “Ticket page”.',
            },
            {
              title: 'Stop sales / deactivate my ticket shop',
              text: 'You can (temporarily) stop the sale of your event. Go to the “Event page”.',
            },
            {
              title: 'I want to sell a group ticket',
              text: 'Create a ticket via "Ticket page" and indicate the name of the group ticket, the total capacity of all group tickets that you want to sell, and the total price of the group ticket.',
            },
            {
              title: 'Sending guest list tickets',
              text: 'Via "Internal shop", internal shop has the possibilities to send out any ticket with any price.',
            },
            {
              title: 'I want to increase/decrease my ticket sales capacity?',
              text: 'Go to "Ticket page”.',
            },
            {
              title: 'I want to add an extra/different ticket during sales',
              text: 'Go to “Event page”.',
            },
            {
              title: 'I want to withdraw a ticket from the sale',
              text: 'Go to “Event page”.',
            },
            {
              title:
                'In addition to tickets, I also want to sell coins, parking tickets, merchandise, and the likes.',
              text: 'You can create an additional ticket for this on the "Ticket Page".',
            },
          ],
        },
        {
          title: 'TICKETS & SCANNING',
          subsections: [
            {
              title: 'How do I scan tickets?',
              text: 'To scan the tickets, use the SIXTIX scanner application. You can download this on a smartphone.',
            },
            {
              title:
                'The ticket buyer has not received a ticket and has paid. What can I do?',
              text: 'You can search the buyer in the “Transaction page” and resend his tickets or edit his email and resend it.',
            },
            {
              title: 'Log in to the scanner app.',
              text: 'You can scan tickets via the SIXTIX scanner app. Log in with your username + password or a QR code. If you do not want to share your username + password with a scan team at the door, you can create a login QR code via "Team page".',
            },
            {
              title: 'Problem’s logging in scanner app',
              text: 'Use the same username + password as the account. A login QR code can be created in the account. Go to "Team page", select the event and tickets, save. The QR code can be used to log in with the scanner app.',
            },
            {
              title: 'A person at the door has paid but no ticket. What now?',
              text: 'In the scanner app, a ticket buyer can be searched by name or email address via the magnifying glass and tickets can be scanned. All sales data can be found via the “Event transaction page”. Tickets can be resent through the “Event transaction page”.',
            },
            {
              title: 'Tickets do not scan.',
              text: 'Does the person have a valid ticket? To verify, a ticket can be found “Event transaction page”.',
            },
            {
              title: 'Scan results data',
              text: 'These are visible in the app but also via the dashboard “Event transaction page”.',
            },
            {
              title: 'Scan results problem',
              text: 'Is the phone or scanner connected to the internet? Has the correct event been selected?',
            },
          ],
        },
        {
          title: 'TICKET BUYER',
          subsections: [
            {
              title: 'How do I purchase tickets through your service?',
              text: 'You can purchase tickets by visiting our website. Simply select the event you’re interested in, choose your desired ticket, and proceed to checkout.',
            },
            {
              title: 'Can tickets be scanned from my phone?',
              text: 'Yes, it can.',
            },
            {
              title: 'How do I add a card or ticket to my wallet?',
              text: 'To add a card or ticket to your wallet, press add to wallet button in the confirmation email.',
            },
            {
              title: 'Is "Add to Wallet" secure?',
              text: "Yes, adding items to your wallet is generally secure. Wallet apps use encryption and secure protocols to protect your information. Always ensure you're using official apps and platforms to maintain security.",
            },
            {
              title: 'Can I use my wallet items offline?',
              text: 'Yes, many wallet items, such as tickets, can be accessed offline once they are added. However, some tickets like season pass or real-time may require an internet connection.',
            },
            {
              title: 'My tickets are sealed',
              text: 'If you\'ve purchased tickets to an event, you may have noticed that one or more of your tickets are marked as "sealed". This means that your tickets won’t be available for download until shortly before the event. Organizers use Sealed Tickets to prevent fraud and discourage unfair trading of tickets. The tickets will usually be available a few days before the event.',
            },
            {
              title: 'Where can I request a refund?',
              text: 'Send a request to the promotor/organization?',
            },
            {
              title: 'When can I expect my refund?',
              text: 'When you have to request a refund, after validation your money is instantly on your account.',
            },
            {
              title: 'Tickets not received.',
              text: 'Send a request to the promotor/organization?',
            },
            {
              title: 'I haven’t received a confirmation email',
              text: 'Contact promotor/organization with your transaction ID for validation, organization has the possibility to resend your ticket to proper email address.',
            },
            {
              title: 'Personalization of your tickets',
              text: 'If personalization is needed it will be asked during buying process.',
            },
            {
              title: 'My ticket is invalid or cancelled',
              text: 'If you notice that one or more of your tickets are marked as invalid or cancelled, it means that the ticket(s) will no longer grant you entry to the event. A ticket can be invalidated or cancelled for various reasons.',
            },
            {
              title: 'My payment was cancelled',
              text: 'Unfortunately, your order has been cancelled. Your tickets weren’t reserved; therefore, you do not have valid tickets for the event. You could try placing a new order with a different payment method.',
            },
          ],
        },
      ],
    },
    yourSixElements: {
      shop: [
        {
          title: 'Full white-label',
          text: "Your brand is the connection between your buyer and you. That's why we take this fact serious, from the data info that is requirement for purchase till colors of your shop. Even the buyer flow.",
          label: 'full-white-label',
        },
        {
          title: 'All type of shop available',
          text: 'Seating / Time slots / products / regular ticketing / season card / memberships / reservation / pre-register.\nWhat you want to sell, and how? You know your product better than we do. We are focussing to cover all possibilities and to maintain a user-friendly user flow.',
          label: 'all-type-of-shop',
        },
        {
          title: 'Secured Costumer experience',
          text: 'Put your event to the next level. With the latest technology available. Seamless integration with apple and google wallet for an easy excess experience. Or protect secondary market with dynamic QR. Rather high end? Use our protected NFC solutions for physical cards.',
          label: 'secured-costumer',
        },
        {
          title: 'Personal contact',
          text: "Create a communication channel by using Buyer / Member login. It's more than only a chat function. Buyer/Members will have a clear profile with purchases, special 1on1 deals or early access to sudden products or tickets.",
          label: 'personal-contact',
        },
        {
          title:
            'Multiple shops in shop (tracking / invites / discount / secured)',
          text: "We understand the need of selling, so we tried to make it as usable and flexible as possible. Selling true different links to track your statistics and improve per campaign. Invite your sponsor's true protected link (with discount), send your host extra guest-list tickets. Sell true ambassadors on the street. It's all possible. Let us know if you have a specific way of selling that you can't do with our software, and we will work together for a solution.",
          label: 'multiple-shops',
        },
      ],
      marketing: [
        {
          title: 'Direct short link',
          text: 'We are with you, time is everything. So no shorturl.com needed, just type your unique reference in create-link environment sixtix.com/reference.',
          label: 'direct-short-link',
        },
        {
          title: 'Iframe integration of any website (and mobile responsive)',
          text: 'Create a ticket button anywhere—offline with QR or online using iframe. Set it once and never worry again; it’s fully responsive and automatically syncs with your event settings.',
          label: 'iframe-integration',
        },
        {
          title: 'P.O.S. app integration',
          text: 'When we say you can sell anywhere, we mean anywhere—not just online. Download our accreditation app with built-in POS functionality, letting you sell any configured product via QR codes, payment links, or Tap2Pay (accepting Apple Pay, Google Pay, and physical cards).',
          label: 'pos-integration',
        },
      ],
      finance: [
        {
          title: 'Choose your online payment options',
          text: "If your preferred payment method isn't available, let us know—we'll integrate it for you!",
          label: 'choose-online-payment-options',
        },
        {
          title: 'Connect tap2pay on P.O.S. app',
          text: 'Turn any Android or iOS device into a local payment terminal, directly connected to the POS functionality within our accreditation app.',
          label: 'connect-tap2pay-pos',
        },
        {
          title: 'Connect your bank account to wallet (split payment)',
          text: "We don't want to handle your money directly, so we've connected your bank account to our payment gateway. Payments are processed instantly on your behalf, automatically splitting the amount into:\n1) product fee,\n2) payment provider fee, and\n3) your earnings.\nEveryone receives immediate access to their cleared balance, depending on the chosen payment method.",
          label: 'connect-your-bank',
        },
        {
          title: 'Choose your pay day',
          text: 'Schedule payouts as often as you need. We understand that healthy cash flow is essential for efficient production.',
          label: 'choose-your-pay-day',
        },
        {
          title: 'Control your refunds and cancellations',
          text: "With full control over your ticket balance, you never have to wait to issue refunds. From now on, you'll have instant insights into cancellations and detailed information about every transaction.\nNO, from now on you have all the control!",
          label: 'control-your-refunds',
        },
      ],
      statistics: [
        {
          title: 'Connect any online tracking',
          text: 'GTM is fully integrated with our own internal tagging system. Enrich your audience database by leveraging every feature Google Tag Manager offers, plus additional internal tags for products or your shop. Easily organize your database by interests or buying behavior—such as artist names, ticket types, purchase values, or specific product choices—to optimize your marketing strategy.',
          label: 'connect-online-tracking',
        },
        {
          title: 'Customize your data requirements for shop sales',
          text: 'Easily add custom fields to your info form—such as yes/no, multiple-choice (ABC), or open-ended questions.',
          label: 'customize-your-data',
        },
        {
          title: 'Activate buyer login',
          text: "We collect valuable data, such as previous purchases, preferred sales channels, and buying patterns (e.g., early-bird buyers). By activating buyer profiles, you'll gain clear, actionable insights into your customers.",
          label: 'activate-buyer-login',
        },
        {
          title: 'Create member login for loyalty and communication',
          text: 'Offer your customers their own login area, providing a convenient overview of all purchases and a space to update personal data or request support. You can also reward members through loyalty programs like early access to sales or personalized offers.',
          label: 'create-member-login',
        },
        {
          title: 'Publish your own fan-base application',
          text: 'Another powerful solution we offer is our white-label app, WE-DO—a personalized community-building platform and dedicated communication channel, tailored specifically to your needs and those of your customers.',
          label: 'publish-your-fan-base',
        },
      ],
      settings: [
        {
          title: 'Easy login by TEAMS',
          text: 'Our accreditation app is versatile yet easy to set up. Quickly create teams with secure logins (QR or password) and assign custom permissions per user to track individual analytics. Easily manage access levels—from purchase validation only to viewing live statistics. With our integrated POS feature, you can even sell and validate simultaneously.',
          label: 'easy-login-teams',
        },
        {
          title: 'Sell and scan at the same time at the same device',
          text: 'The integrated POS feature lets you effortlessly sell and validate tickets (or products) using the same device and app—just swipe directly from the screen.',
          label: 'sell-and-scan',
        },
        {
          title: 'Online and offline scanning',
          text: 'No internet or stuck with a weak connection (1G/2G)? No worries—simply set up your scanners in advance and create an internal Wi-Fi network to sync seamlessly between devices.',
          label: 'online-and-offline-scanning',
        },
        {
          title: 'Use any brand of device',
          text: 'IOS/OS ANDROID/GOOGLE, Huawei, MICROSOFT, Linux.',
          label: 'use-any-device',
        },
        {
          title: 'Live statistics',
          text: 'Access your data anytime—directly through the app (once set up) or online with an internet connection. With an impressive scan rate (multiple devices syncing in seconds, even on minimal connections), your stats update instantly, keeping you effortlessly informed.',
          label: 'live-statistics',
        },
        {
          title: 'Role management',
          text: 'Easily manage roles and permissions across different teams. Control who sees statistics—and to what extent—whether per device, entrance, or ticket type. Everything is customizable through our TEAMS setup.',
          label: 'role-management',
        },
      ],
      dashboard: [
        {
          title: 'Control your secondary ticketing yourself',
          text: 'By locking your QR code, you gain access to our internal Secondary Ticketing System, featuring options like partial refunds, loyalty refunds, and guaranteed refunds (full or percentage-based).',
          label: 'controle-your-secondary-ticketing',
        },
        {
          title: 'Control who can by what at what moment',
          text: 'Reward your loyal fans with early access or share exclusive deals with your "friends-only WhatsApp group," without compromising trust among other customers.',
          label: 'control-who-can-at-moment',
        },
        {
          title: 'Control who can sell at what price, on what channel',
          text: 'Whether through POS, secure or open online links, invites, or guest lists—manage everything effortlessly by creating Multiple Links in our system.',
          label: 'control-who-can-sell',
        },
        {
          title: 'Control your cashflow and invoice model',
          text: "It's your money, not ours. We have a zero-touch policy.",
          label: 'control-your-cashflow',
        },
        {
          title: 'Control your "product / company" no it should hold you back',
          text: "We're always looking to add new features and improvements—and there's no better judge than you! Let us know what's missing or what you'd like added, and together we'll make it happen.",
          label: 'control-your-product',
        },
      ],
    },
    loginModal: {
      title: 'Choose your Dashboard for your Event',
      enterDashboard: 'ENTER DASHBOARD',
      launch: {
        title: 'Launch',
        link: 'http://dev-tapp.sixtix.com/login',
        phrase: 'Go live in minutes. No hassle',
        features: [
          'Direct access to ticket marketplace',
          'Guestlist & invite management',
          'Pre-registration forms',
          'Festivals, nightlife, community events, pop-ups.',
        ],
        description:
          'Event creators who want to publish tickets quickly and gain immediate market access.',
      },
      control: {
        title: 'Control',
        link: `https://app.sixtix.com/login`,
        phrase: 'Your venue. Your audience. Your rules',
        features: [
          'Seated ticketing & venue mapping',
          'Membership access & loyalty features',
          'Direct ticket offers to buyers (B2C)',
          'Sport events, seated shows, clubs with members, theaters.',
        ],
        description:
          'Organizers working with seated layouts, memberships, or direct customer communication.',
      },
      pro: {
        title: 'Pro',
        link: '/',
        phrase: '',
        features: [
          'Advanced analytics & insights',
          'Custom drag & drop interface',
          'Shop-in-shop: sell tickets & more',
          'Multi-ebvent organizers, brands, agencies, high-end experiences.',
        ],
        description:
          'Organizers focused on data, branding, and additional revenue opportunities.',
      },
    },
    acceptation: {
      title:
        'We willen en kunnen niks zonder jouw toestemming doen! Transparant & eerlijk, dat is waar we voor staan.',
      'I accept ': 'Ik accepteer ',
      submit: 'Activeer mijn account',
    },
  },
  nl: {
    common: {
      lostTicket: 'Lost your Ticket?',
      login: 'Login',
      contact: 'Contact',
      policy: 'Privacy Policy',
      terms: 'Terms of Service',
      cookie: 'Cookieverklaring',
      learnMore: 'Learn More',
      knowledgeBtn: 'Knowledge base',
      ourPartnerships: 'Our loyal Partnerships',
    },
    hero: {
      title: 'Your full control in ticketing',
      description:
        'Eén platform waarop je al je commerciële activiteiten kunt beheren. Maak eenvoudig verbinding met je publiek, verkoop efficiënt je producten en ontvang direct je betalingen.',
      features: 'Easy setup - Efficient sales - Instant payment',
      requestDemo: 'Ontvang demo',
    },
    asEasyAs: {
      title: 'It’s as easy as',
      sell: {
        title: 'Sell',
        text: 'Eén systeem dat jou alle benodigde tools geeft. Verkoop alles wat je wilt, waar en wanneer je maar wilt. Online via je website of social media, of persoonlijk met een kassasysteem (POS). Van tickets en producten tot reserveringen en zelfs maandelijkse abonnementen — alles is mogelijk.',
      },
      collect: {
        title: 'Collect',
        text: 'We weten dat cashflow essentieel is voor het succes van jouw bedrijf. Daarom hebben we jouw bankrekening direct aan je winkel gekoppeld via ons zero-touch beleid. Elke betaling wordt direct gesplitst in jouw inkomsten, onze productkosten en de transactiekosten van de betaalprovider—eenvoudig en transparant.',
      },
      monetize: {
        title: 'Monetize',
        text: 'Wij geloven in de kracht van jouw data. Daarom hebben we diverse functies ontwikkeld om je winst te maximaliseren en extra inkomstenstromen te creëren voor jouw eindgebruikers (ticketkopers). Onze white-label community-app maakt het eenvoudig om extra verkoopmomenten te genereren en integreert naadloos met externe sponsor- en marketingcampagnes.',
      },
    },
    yourSix: {
      title: 'Your six of SIXTIX',
      shop: {
        title: 'Shop',
        text1: 'CREATE ',
        text2: ' SHOP',
        your: 'YOUR',
        tooltip:
          "”From customizing colors and requirements to offering buyer discounts—whether you need assigned seating or reservations, we've got you covered.”",
      },
      marketing: {
        title: 'Marketing',
        text1: 'SELL ',
        text2: ' PRODUCTS',
        your: 'YOUR',
        tooltip:
          '“Manage everything easily from your phone, website, or own application. Set it up quickly via your personal dashboard, giving you full control over what, when, where, and who.”',
      },
      finance: {
        title: 'Finance',
        text1: 'GET ',
        text2: ' MONEY',
        your: 'YOUR',
        tooltip:
          '“With our zero-touch money policy, you have direct control over all your cash flow settings.”',
      },
      statistics: {
        title: 'Statistics',
        text1: 'GROW ',
        text2: ' DATABASE',
        your: 'YOUR',
        tooltip:
          '“Your active database is your greatest asset—start leveraging it!”',
      },
      settings: {
        title: 'Settings',
        text1: 'CONTROL ',
        text2: ' ENTRANCE',
        your: 'YOUR',
        tooltip: '“Great customer value starts with great service.”',
      },
      dashboard: {
        title: 'Dashboard',
        text1: 'GET ',
        text2: ' CONTROL',
        your: 'YOUR',
        tooltip: '”The days of depending on your provider are over!”',
      },
    },
    takingBackControl: {
      title: 'Taking back Control!',
      slider: 'GLOBAL NEWSFEED SLIDER',
    },
    agenda: {
      title: 'Agenda',
      showMore: 'Show more',
      tickets: 'Tickets',
      startDate: 'Start date',
      endDate: 'End date',
    },
    about: {
      title: 'What do you want to know about us?',
      sectionsList: [
        {
          title: 'FAQ SIXTIX',
          subsections: [
            {
              title: 'How do I use SIXTIX?',
              text: 'Just sign up to create your account as a seller, buyer or reseller — and then start creating your events. SIXTIX makes it easy to create, manage, and promote your events. From email marketing to social media integration, you’ll discover advanced tools designed to help you sell more tickets and grow your business all in one place.',
            },
          ],
        },
        {
          title: 'TICKET DASHBOARD',
          subsections: [
            {
              title: 'How do I create multiple ticket types on SIXTIX?',
              text: 'With SIXTIX, you can easily create multiple ticket types such as Early Bird or VIP, optimizing your online sales by appealing to different budgets and encouraging more ticket purchases.',
            },
            {
              title: 'Where can I find support that can help me with sales?',
              text: 'Under the heading "Support" in your dashboard.',
            },
            {
              title: 'Where can I find visitor data and sales insights?',
              text: 'Under sales (statistics), data can be found on sales statistics. And downloadable on the “Report page”.',
            },
            {
              title: 'Can I offer special prize tickets?',
              text: 'You can send out any ticket with a special prize through your internal shop.',
            },
            {
              title: 'Do you offer special pricing for nonprofits?',
              text: 'Yes, we offer discounted Ticketing Fees on donation tickets, so more of your funds go directly to your cause. We’re committed to supporting non-profits with tailored features designed to help you and your community thrive.',
            },
            {
              title: 'What are Sealed Tickets?',
              text: 'Sealed Tickets are tickets that become available for download shortly before an event starts. We do this at the organizer’s request to prevent fraud and discourage unfair trading of tickets.',
            },
            {
              title: 'My ticket shop is no longer active. What now?',
              text: 'Check if the time and date of the event are set correctly. You do this via “Event page”, edit event. Check if the event is still active. You do this via “Event page”, edit event.',
            },
            {
              title:
                'My tickets are no longer visible in the ticket shop. What now?',
              text: 'Check in the options of the ticket whether the ticket date and time are set correctly. You do this via “Ticket page”.',
            },
            {
              title: 'Stop sales / deactivate my ticket shop',
              text: 'You can (temporarily) stop the sale of your event. Go to the “Event page”.',
            },
            {
              title: 'I want to sell a group ticket',
              text: 'Create a ticket via "Ticket page" and indicate the name of the group ticket, the total capacity of all group tickets that you want to sell, and the total price of the group ticket.',
            },
            {
              title: 'Sending guest list tickets',
              text: 'Via "Internal shop", internal shop has the possibilities to send out any ticket with any price.',
            },
            {
              title: 'I want to increase/decrease my ticket sales capacity?',
              text: 'Go to "Ticket page”.',
            },
            {
              title: 'I want to add an extra/different ticket during sales',
              text: 'Go to “Event page”.',
            },
            {
              title: 'I want to withdraw a ticket from the sale',
              text: 'Go to “Event page”.',
            },
            {
              title:
                'In addition to tickets, I also want to sell coins, parking tickets, merchandise, and the likes.',
              text: 'You can create an additional ticket for this on the "Ticket Page".',
            },
          ],
        },
        {
          title: 'TICKETS & SCANNING',
          subsections: [
            {
              title: 'How do I scan tickets?',
              text: 'To scan the tickets, use the SIXTIX scanner application. You can download this on a smartphone.',
            },
            {
              title:
                'The ticket buyer has not received a ticket and has paid. What can I do?',
              text: 'You can search the buyer in the “Transaction page” and resend his tickets or edit his email and resend it.',
            },
            {
              title: 'Log in to the scanner app.',
              text: 'You can scan tickets via the SIXTIX scanner app. Log in with your username + password or a QR code. If you do not want to share your username + password with a scan team at the door, you can create a login QR code via "Team page".',
            },
            {
              title: 'Problem’s logging in scanner app',
              text: 'Use the same username + password as the account. A login QR code can be created in the account. Go to "Team page", select the event and tickets, save. The QR code can be used to log in with the scanner app.',
            },
            {
              title: 'A person at the door has paid but no ticket. What now?',
              text: 'In the scanner app, a ticket buyer can be searched by name or email address via the magnifying glass and tickets can be scanned. All sales data can be found via the “Event transaction page”. Tickets can be resent through the “Event transaction page”.',
            },
            {
              title: 'Tickets do not scan.',
              text: 'Does the person have a valid ticket? To verify, a ticket can be found “Event transaction page”.',
            },
            {
              title: 'Scan results data',
              text: 'These are visible in the app but also via the dashboard “Event transaction page”.',
            },
            {
              title: 'Scan results problem',
              text: 'Is the phone or scanner connected to the internet? Has the correct event been selected?',
            },
          ],
        },
        {
          title: 'TICKET BUYER',
          subsections: [
            {
              title: 'How do I purchase tickets through your service?',
              text: 'You can purchase tickets by visiting our website. Simply select the event you’re interested in, choose your desired ticket, and proceed to checkout.',
            },
            {
              title: 'Can tickets be scanned from my phone?',
              text: 'Yes, it can.',
            },
            {
              title: 'How do I add a card or ticket to my wallet?',
              text: 'To add a card or ticket to your wallet, press add to wallet button in the confirmation email.',
            },
            {
              title: 'Is "Add to Wallet" secure?',
              text: "Yes, adding items to your wallet is generally secure. Wallet apps use encryption and secure protocols to protect your information. Always ensure you're using official apps and platforms to maintain security.",
            },
            {
              title: 'Can I use my wallet items offline?',
              text: 'Yes, many wallet items, such as tickets, can be accessed offline once they are added. However, some tickets like season pass or real-time may require an internet connection.',
            },
            {
              title: 'My tickets are sealed',
              text: 'If you\'ve purchased tickets to an event, you may have noticed that one or more of your tickets are marked as "sealed". This means that your tickets won’t be available for download until shortly before the event. Organizers use Sealed Tickets to prevent fraud and discourage unfair trading of tickets. The tickets will usually be available a few days before the event.',
            },
            {
              title: 'Where can I request a refund?',
              text: 'Send a request to the promotor/organization?',
            },
            {
              title: 'When can I expect my refund?',
              text: 'When you have to request a refund, after validation your money is instantly on your account.',
            },
            {
              title: 'Tickets not received.',
              text: 'Send a request to the promotor/organization?',
            },
            {
              title: 'I haven’t received a confirmation email',
              text: 'Contact promotor/organization with your transaction ID for validation, organization has the possibility to resend your ticket to proper email address.',
            },
            {
              title: 'Personalization of your tickets',
              text: 'If personalization is needed it will be asked during buying process.',
            },
            {
              title: 'My ticket is invalid or cancelled',
              text: 'If you notice that one or more of your tickets are marked as invalid or cancelled, it means that the ticket(s) will no longer grant you entry to the event. A ticket can be invalidated or cancelled for various reasons.',
            },
            {
              title: 'My payment was cancelled',
              text: 'Unfortunately, your order has been cancelled. Your tickets weren’t reserved; therefore, you do not have valid tickets for the event. You could try placing a new order with a different payment method.',
            },
          ],
        },
      ],
    },
    yourSixElements: {
      shop: [
        {
          title: 'Full white-label',
          text: 'Jouw merk is de verbinding tussen jou en je klant. Daarom nemen wij dit serieus: van de gegevens die nodig zijn bij een aankoop, tot de kleuren van jouw webshop en zelfs de volledige klantreis.',
          label: 'full-white-label',
        },
        {
          title: 'All type of shop available',
          text: 'Seating / Time slots / products / regular ticketing / season card / memberships / reservation / pre-register.\nWat wil je verkopen, en hoe? Jij kent jouw product beter dan wij. Wij richten ons erop om alle mogelijkheden af te dekken en tegelijkertijd een gebruiksvriendelijke ervaring te bieden.',
          label: 'all-type-of-shop',
        },
        {
          title: 'Secured Costumer experience',
          text: 'Breng jouw evenement naar het volgende niveau met de nieuwste beschikbare technologieën. Naadloze integratie met Apple en Google Wallet voor een soepele toegangsbeleving. Of bescherm de secundaire markt met dynamische QR-codes. Liever exclusiever? Maak gebruik van onze beveiligde NFC-oplossingen voor fysieke kaarten.',
          label: 'secured-costumer',
        },
        {
          title: 'Personal contact',
          text: 'Creëer een communicatiekanaal via een Buyer / Member login. Dit gaat verder dan alleen een chatfunctie. Buyer / Member krijgen een duidelijk profiel met hun aankopen, speciale persoonlijke aanbiedingen en vroegtijdige toegang tot exclusieve producten of tickets.',
          label: 'personal-contact',
        },
        {
          title:
            'Multiple shops in shop (tracking / invites / discount / secured)',
          text: 'Wij begrijpen hoe belangrijk verkoop voor jou is. Daarom hebben we het verkoopproces zo gebruiksvriendelijk en flexibel mogelijk gemaakt. Verkoop via verschillende links om je statistieken te volgen en campagnes te verbeteren. Nodig je sponsors uit via een beveiligde link (met korting), stuur extra guest list tickets naar je hosts, of verkoop via ambassadeurs op straat—alles is mogelijk. Heb je een specifieke verkoopmethode die onze software nog niet ondersteunt? Laat het ons weten, dan zoeken we samen naar een oplossing.',
          label: 'multiple-shops',
        },
      ],
      marketing: [
        {
          title: 'Direct short link',
          text: "We staan voor je klaar, tijd is kostbaar. Daarom geen gedoe met korte URL's (.com) nodig; typ gewoon jouw unieke referentie in de create-link omgeving.",
          label: 'direct-short-link',
        },
        {
          title: 'Iframe integration of any website (and mobile responsive)',
          text: 'Plaats overal een ticketknop—offline via QR-code of online via iframe. Stel het één keer in en je hebt er geen omkijken meer naar; de knop is volledig responsive en synchroniseert automatisch met jouw evenementinstellingen.',
          label: 'iframe-integration',
        },
        {
          title: 'P.O.S. app integration',
          text: 'Als wij zeggen dat je overal kunt verkopen, bedoelen we écht overal—niet alleen online. Download onze accreditatie-app met geïntegreerde kassafunctie (POS) waarmee je ieder ingesteld product kunt verkopen via QR-codes, betaallinks of Tap2Pay (met ondersteuning voor Apple Pay, Google Pay en fysieke betaalkaarten).',
          label: 'pos-integration',
        },
      ],
      finance: [
        {
          title: 'Choose your online payment options',
          text: 'Staat jouw favoriete betaalmethode er niet tussen? Laat het ons weten—dan integreren we deze speciaal voor jou!',
          label: 'choose-online-payment-options',
        },
        {
          title: 'Connect tap2pay on P.O.S. app',
          text: 'Maak van elk Android- of iOS-apparaat een mobiele betaalterminal, direct gekoppeld aan de kassafunctie binnen onze accreditatie-app.',
          label: 'connect-tap2pay-pos',
        },
        {
          title: 'Connect your bank account to wallet (split payment)',
          text: 'We willen jouw geld niet direct beheren, daarom hebben we je bankrekening gekoppeld aan onze betaalgateway. Betalingen worden onmiddellijk namens jou verwerkt en automatisch verdeeld in: 1) productkosten, 2) transactiekosten van de betaalprovider en 3) jouw inkomsten.\nIedereen heeft direct toegang tot het beschikbare saldo, afhankelijk van de gekozen betaalmethode.',
          label: 'connect-your-bank',
        },
        {
          title: 'Choose your pay day',
          text: 'Plan uitbetalingen zo vaak als je nodig hebt. We begrijpen dat een gezonde cashflow essentieel is voor een efficiënte bedrijfsvoering.',
          label: 'choose-your-pay-day',
        },
        {
          title: 'Control your refunds and cancellations',
          text: 'Met volledige controle over je ticketbalans hoef je nooit meer te wachten met terugbetalingen. Vanaf nu heb je direct inzicht in annuleringen en gedetailleerde informatie over elke transactie.\nNO, from now on you have all the control!',
          label: 'control-your-refunds',
        },
      ],
      statistics: [
        {
          title: 'Connect any online tracking',
          text: 'GTM is volledig geïntegreerd met ons eigen interne taggingsysteem. Verrijk jouw doelgroep-database door optimaal gebruik te maken van alle functies van Google Tag Manager én aanvullende interne tags voor producten of je shop. Orden je database eenvoudig op interesses of koopgedrag—zoals artiestennamen, tickettypes, aankoopwaarde of specifieke productkeuzes—om je marketingstrategie te optimaliseren.',
          label: 'connect-online-tracking',
        },
        {
          title: 'Customize your data requirements for shop sales',
          text: 'Voeg eenvoudig aangepaste velden toe aan je informatieformulier—zoals ja/nee, meerkeuzevragen (ABC) of open vragen.',
          label: 'customize-your-data',
        },
        {
          title: 'Activate buyer login',
          text: 'Wij verzamelen waardevolle data, zoals eerdere aankopen, favoriete verkoopkanalen en koopgedrag (bijvoorbeeld early-bird kopers). Door koperprofielen te activeren krijg je heldere, bruikbare inzichten in jouw klanten.',
          label: 'activate-buyer-login',
        },
        {
          title: 'Create member login for loyalty and communication',
          text: "Bied jouw klanten hun eigen login-omgeving aan, met een handig overzicht van alle aankopen en een plek om persoonlijke gegevens bij te werken of support aan te vragen. Daarnaast kun je leden belonen via loyaliteitsprogramma's, zoals vroegtijdige toegang tot verkoopmomenten of gepersonaliseerde aanbiedingen.",
          label: 'create-member-login',
        },
        {
          title: 'Publish your own fan-base application',
          text: 'Een andere krachtige oplossing die wij bieden is onze white-label app, WE-GIVE—een gepersonaliseerd platform voor het bouwen van communities en een speciaal communicatiekanaal, volledig afgestemd op jouw wensen en die van je klanten.',
          label: 'publish-your-fan-base',
        },
      ],
      settings: [
        {
          title: 'Easy login by TEAMS',
          text: 'Onze accreditatie-app is veelzijdig en toch eenvoudig in gebruik. Maak snel teams aan met beveiligde logins (QR of wachtwoord) en wijs aangepaste rechten toe per gebruiker om individuele statistieken bij te houden. Beheer eenvoudig verschillende toegangsniveaus—van enkel aankoopvalidatie tot het bekijken van live statistieken. Met onze geïntegreerde kassafunctie kun je zelfs tegelijkertijd verkopen en valideren.',
          label: 'easy-login-teams',
        },
        {
          title: 'Sell and scan at the same time at the same device',
          text: 'Met de geïntegreerde kassafunctie (POS) kun je moeiteloos tickets (of producten) verkopen én valideren met hetzelfde apparaat en dezelfde app—gewoon door direct op het scherm te swipen.',
          label: 'sell-and-scan',
        },
        {
          title: 'Online and offline scanning',
          text: 'Geen internet of zit je vast aan een zwakke verbinding (1G/2G)? Geen zorgen—stel je scanners vooraf in en creëer een intern Wi-Fi-netwerk zodat je apparaten naadloos met elkaar synchroniseren.',
          label: 'online-and-offline-scanning',
        },
        {
          title: 'Use any brand of device',
          text: 'IOS/OS ANDROID/GOOGLE, Huawei, MICROSOFT, Linux.',
          label: 'use-any-device',
        },
        {
          title: 'Live statistics',
          text: 'Krijg altijd toegang tot je data—direct via de app (na eenmalige instelling) of online met een internetverbinding. Dankzij een indrukwekkende scansnelheid (meerdere apparaten synchroniseren binnen seconden, zelfs bij minimale verbindingen), worden je statistieken onmiddellijk bijgewerkt, zodat je altijd moeiteloos op de hoogte bent.',
          label: 'live-statistics',
        },
        {
          title: 'Role management',
          text: 'Beheer eenvoudig rollen en rechten binnen verschillende teams. Bepaal wie statistieken mag zien—en in welke mate—per apparaat, ingang of tickettype. Alles is volledig aanpasbaar via onze TEAMS-configuratie.',
          label: 'role-management',
        },
      ],
      dashboard: [
        {
          title: 'Control your secondary ticketing yourself',
          text: 'Door je QR-code te vergrendelen krijg je toegang tot ons interne Secondary Ticketing System, met opties zoals gedeeltelijke terugbetalingen, loyaliteits-terugbetalingen en gegarandeerde terugbetalingen (volledig of op procentbasis).',
          label: 'controle-your-secondary-ticketing',
        },
        {
          title: 'Control who can by what at what moment',
          text: 'Beloon je trouwe fans met vroegtijdige toegang of deel exclusieve deals in je "friends-only WhatsApp-group," zonder het vertrouwen van je andere klanten te schaden.',
          label: 'control-who-can-at-moment',
        },
        {
          title: 'Control who can sell at what price, on what channel',
          text: 'Of het nu via een kassasysteem (POS), beveiligde of open online links, uitnodigingen of gastenlijsten is—beheer alles moeiteloos door Meerdere Links aan te maken in ons systeem.',
          label: 'control-who-can-sell',
        },
        {
          title: 'Control your cashflow and invoice model',
          text: 'Het is jouw geld, niet het onze. Wij hanteren een zero-touch beleid.',
          label: 'control-your-cashflow',
        },
        {
          title: 'Control your "product / company" no it should hold you back',
          text: 'We zijn voortdurend op zoek naar nieuwe functies en verbeteringen—en er is geen betere beoordelaar dan jij! Laat ons weten wat je mist of graag toegevoegd zou zien, en samen maken we het mogelijk.',
          label: 'control-your-product',
        },
      ],
    },
    loginModal: {
      title: 'Choose your Dashboard for your Event',
      enterDashboard: 'ENTER DASHBOARD',
      launch: {
        title: 'Launch',
        link: 'https://launch.sixtix.nl/login',
        phrase: 'Go live in minutes. No hassle',
        features: [
          'Direct access to ticket marketplace',
          'Guestlist & invite management',
          'Pre-registration forms',
          'Festivals, nightlife, community events, pop-ups.',
        ],
        description:
          'Event creators who want to publish tickets quickly and gain immediate market access.',
      },
      control: {
        title: 'Control',
        link: `https://app.sixtix.com/login`,
        phrase: 'Your venue. Your audience. Your rules',
        features: [
          'Seated ticketing & venue mapping',
          'Membership access & loyalty features',
          'Direct ticket offers to buyers (B2C)',
          'Sport events, seated shows, clubs with members, theaters.',
        ],
        description:
          'Organizers working with seated layouts, memberships, or direct customer communication.',
      },
      pro: {
        title: 'Pro',
        link: '/',
        phrase: '',
        features: [
          'Advanced analytics & insights',
          'Custom drag & drop interface',
          'Shop-in-shop: sell tickets & more',
          'Multi-ebvent organizers, brands, agencies, high-end experiences.',
        ],
        description:
          'Organizers focused on data, branding, and additional revenue opportunities.',
      },
    },
    acceptation: {
      title:
        'We willen en kunnen niks zonder jouw toestemming doen! Transparant & eerlijk, dat is waar we voor staan.',
      'I accept ': 'Ik accepteer ',
      submit: 'Activeer mijn account',
    },
  },
};

export const getTranslation = () => {
  const domen = getRegion();

  switch (domen) {
    case 'rs':
      moment.locale('sr');
      return translation.rs;

    case 'fr':
      moment.locale('fr');
      return translation.fr;

    case 'nl':
      moment.locale('de');
      return translation.nl;

    default:
      moment.locale('en');
      return translation.com;
  }
};
